const NUMBER_LOCALE = 'en-US';
const CURRENCY_DECIMALS = Object.freeze({ COP: 0 });
const DEFAULT_DECIMALS = 2;
const UNIT_PRICE_MAX_DECIMALS = 3;
const QUANTITY_MAX_DECIMALS = 3;
const NO_DECIMALS = 0;
const NON_ZERO_DIGIT = /[1-9]/;
const MINUS_SIGN = '-';
const PLUS_SIGN = '+';
const NO_SIGN = '';

function currencyDecimals(currency) {
  const decimals = CURRENCY_DECIMALS[currency];
  return Number.isInteger(decimals) ? decimals : DEFAULT_DECIMALS;
}

function formatDigits(value, minimumFractionDigits, maximumFractionDigits) {
  return new Intl.NumberFormat(NUMBER_LOCALE, { minimumFractionDigits, maximumFractionDigits }).format(value);
}

function isShownAsZero(digits) {
  return !NON_ZERO_DIGIT.test(digits);
}

function signedText({ amount, currency, minimumDecimals, maximumDecimals, positiveSign }) {
  const digits = formatDigits(Math.abs(amount), minimumDecimals, maximumDecimals);
  if (isShownAsZero(digits)) return `${currency} ${digits}`;

  return `${amount < 0 ? MINUS_SIGN : positiveSign}${currency} ${digits}`;
}

export function formatMoney(amount, currency) {
  const decimals = currencyDecimals(currency);
  return signedText({ amount, currency, minimumDecimals: decimals, maximumDecimals: decimals, positiveSign: NO_SIGN });
}

export function formatSignedMoney(amount, currency) {
  const decimals = currencyDecimals(currency);
  return signedText({ amount, currency, minimumDecimals: decimals, maximumDecimals: decimals, positiveSign: PLUS_SIGN });
}

export function formatUnitPrice(amount, currency) {
  const decimals = currencyDecimals(currency);
  return signedText({
    amount,
    currency,
    minimumDecimals: decimals,
    maximumDecimals: Math.max(decimals, UNIT_PRICE_MAX_DECIMALS),
    positiveSign: NO_SIGN,
  });
}

export function formatQuantity(quantity) {
  return formatDigits(quantity, NO_DECIMALS, QUANTITY_MAX_DECIMALS);
}
